"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGroupRequests = void 0;
var react_1 = require("react");
var GroupRequestsContext_1 = require("./GroupRequestsContext");
function useGroupRequests() {
    var context = react_1.useContext(GroupRequestsContext_1.GroupRequestsContext);
    if (!context) {
        throw new Error('`useGroupRequests()` must be used within a `GroupRequestsContext`');
    }
    return context;
}
exports.useGroupRequests = useGroupRequests;
//# sourceMappingURL=useGroupRequests.js.map